import grispiApi from '../../../apis/grispiApi';
import { CreateAutomationFormValues } from '../../../components/Forms/CreateAutomationForm';
import { EditAutomationFormValues } from '../../../components/Forms/EditAutomationForm';

type CreateAutomationPostData = Omit<CreateAutomationFormValues, 'actions' | 'triggerType' | 'userId' | 'userType'> & {
    action: CreateAutomationFormValues['actions'];
    userId: number;
};
export const createAutomation = async (createAutomationPostData: CreateAutomationPostData): Promise<void> => {
    await grispiApi.post('/automations/definitions', createAutomationPostData);
};

export const editAutomation = async (
    editAutomationPostData: Omit<EditAutomationFormValues, 'actions' | 'triggerType' | 'userId' | 'userType'> & {
        action: CreateAutomationFormValues['actions'];
        userId: number;
    }
): Promise<void> => {
    await grispiApi.put('/automations/definitions', editAutomationPostData);
};

export const deleteAutomation = async (id: number): Promise<void> => {
    await grispiApi.delete(`/automations/definitions/${id}`);
};

export const disableAutomation = async (id: number): Promise<void> => {
    await grispiApi.post(`/automations/definitions/${id}/deactivation`);
};

export const enableAutomation = async (id: number): Promise<void> => {
    await grispiApi.delete(`/automations/definitions/${id}/deactivation`);
};

export const runAutomation = async (id: number): Promise<void> => {
    await grispiApi.post(`/automations/definitions/${id}/execute`);
};
